import React from 'react'

const SectionTitle = ({ text }) => (
  <h2 className="lh-title fw6 f5 f4-m f3-l tc relative center mt0 mb2 dib">
    {text}
  </h2>
)

export default SectionTitle
